/**
 * Naming — the customer-facing names both apps print.
 *
 * One copy of each name, imported by the API (error messages, approval cards, timeline entries) and
 * the UI (labels and copy), so a rename is one line here and the two cannot drift apart.
 *
 * Sentences that use a name are written so any name fits — "a campaign on Pay Later terms", not
 * "a Pay Later campaign", which breaks the moment a name starts with a vowel.
 *
 * What a rename does NOT reach: text already stored (timeline entries, the acceptance wording a
 * client agreed to) keeps the name it was written with, which is right for a record; and the
 * SendGrid templates, whose copy lives in SendGrid.
 */

/** The funding models, by the name a client knows them by. Keyed by the internal model. */
export const FUNDING_MODEL_NAME = {
  prepaid: "Prepaid",
  automated: "Pay-as-you-give",
  postpaid: "Pay Later",
} as const;

export type FundingModelKey = keyof typeof FUNDING_MODEL_NAME;

/** Max length of a user-typed campaign name. campaigns.title stays varchar(255). */
export const CAMPAIGN_NAME_MAX_LENGTH = 60;

/**
 * Bounds of a gift-link quantity: the builder's manual link count and one Add gift links request.
 * The API's DTOs refuse a count outside them; the UI's quantity inputs clamp to them.
 */
export const LINK_QTY_MIN = 1;
export const LINK_QTY_MAX = 10_000;
